import { Component, ChangeDetectorRef } from '@angular/core';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { ABOUT_DATA } from '../../Pages/National/about/about.data';
import { BaseComponent } from '../../Pages/base.component';
import { SchoolApiService } from '../../Services/schoolApi.service';
import { DOMAIN } from '../../../configurations/defaultConfigs';
import { DOMAIN_TYPE, NATIONAL_PAGES, SCHEMA_TYPE } from '../../constants';
import { IResponse } from '../../Models/response.model';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent extends BaseComponent {
  public getInTouch = ABOUT_DATA.contact;
  public subscribedEmail = '';
  public footerLinks: any = [];
  public linksPerDomain = {
    national: [
      {
        name: 'home',
        href: '/home',
      },
      {
        name: 'admission',
        href: '/academics-admission',
      },
      {
        name: 'news',
        href: '/news',
      },
      {
        name: 'about_us',
        href: '/about',
      },
      {
        name: 'careers',
        href: '/careers',
      },
    ],
    bac: [
      {
        name: 'home',
        href: '/home',
      },
      {
        name: 'admission',
        href: '/admission',
      },
      {
        name: 'news',
        href: '/news',
      },
      {
        name: 'about_us',
        href: '/about',
      },
      {
        name: 'careers',
        href: '/careers',
      },
    ],
  };
  public visitsCount: number;
  public isNational = DOMAIN === DOMAIN_TYPE.NATIONAL;

  constructor(
    schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
    this.footerLinks = this.linksPerDomain[DOMAIN];
  }

  ngOnInit(): void {
    this.schoolApiService
      .getVisitorsCount()
      .subscribe((data: IResponse<number>) => {
        this.visitsCount = data.payload || 0;
      });
  }

  onSubmitEmail(event: any) {
    this.subscribedEmail = event.target.value;
  }

  emailSubscribe() {
    this.schoolApiService
      .emailSubscribe({
        domainType: DOMAIN,
        schemaType: SCHEMA_TYPE.EMAIL,
        articleType: NATIONAL_PAGES.EMAIL.NEWS_LETTER,
        email: this.subscribedEmail,
      })
      .subscribe((data: IResponse<Boolean>) => {
        this.subscribedEmail = '';
      });
  }
}
